import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const project = getProjectBySlug('wraith');

const WraithPage = () => <CaseStudyPage project={project} />;

export default WraithPage;
